import type { SyntheticEvent } from 'react';
import { forwardRef } from 'react';
import { useBlockAppearanceStyles } from '@unifyapps/carbon/no-code/hooks/useBlockAppearanceStyles';
import { Box } from '@unifyapps/ui/components/Box';
import { clsx } from 'clsx';
import { StyleObject } from '@unifyapps/defs/types/styleObject';

type Props = {
  onClick?: (e: SyntheticEvent) => void;
  attributesAndEventListeners?: Record<string, unknown>;
  hasClickEvent?: boolean;
  src?: string;
  alt?: string;
  styles?: Pick<StyleObject, 'padding' | 'margin' | 'borderRadius' | 'height' | 'width'>;
  objectFit?:
    | 'object-contain'
    | 'object-cover'
    | 'object-fill'
    | 'object-none'
    | 'object-scale-down'
    | undefined;
  className?: string;
};

export const Image = forwardRef<HTMLImageElement, Props>(
  (
    { attributesAndEventListeners, hasClickEvent, onClick, src, alt, styles, objectFit, className },
    ref,
  ) => {
    const { className: blockAppearanceClassName, style } = useBlockAppearanceStyles({
      appearanceStyles: styles,
    });

    return (
      <Box
        {...attributesAndEventListeners}
        className={clsx('overflow-hidden', blockAppearanceClassName, className)}
        onClick={onClick}
        ref={ref}
        style={style}
      >
        <img
          alt={alt}
          className={clsx('h-full w-full', objectFit, {
            'cursor-pointer': hasClickEvent,
          })}
          src={src}
        />
      </Box>
    );
  },
);
